// src/config/constants.js

export const LOGO_TEXT = "大帥的數理AI教室";
export const API_URL = "https://mathslover.5609wa.workers.dev";
export const SECURE_API_URL = "https://mathslover-test.5609wa.workers.dev";
export const appId = "chengkai-math-app";

// 靜態配置 (作為預設值)
export const STATIC_CONFIG = {
  announcement: `🎉 歡迎來到大帥的數理 AI 教室！\n\n這裡是你最強大的學習後盾。遇到不會的題目，拍下來傳給我，讓我陪你一起把觀念弄懂！\n\n💡 學習小撇步：\n1. 題目照片請盡量拍清楚、正向。\n2. 看完 AI 解析後，記得自己動筆算一遍。\n3. 善用「舉一反三」功能，確認自己真的學會了！\n\n讓我們一起把數理變簡單吧！💪`,
  notices: [
    "請務必使用真實姓名註冊，方便老師辨識身分並開通權限。",
    "解題過程僅供參考，請同學務必內化為自己的知識。",
    "嚴禁將本系統用於任何形式的考試作弊行為。"
  ],
  disclaimer: "【使用免責聲明】本工具僅供學術輔助參考，不保證 AI 生成結果之完全正確性。使用者應獨立思考，嚴禁依賴 AI 進行考試作弊。本平台不負任何學科成績之法律責任。"
};

// 安全預設值 (會員方案)
export const DEFAULT_PLANS = {
  F: { dailyLimit: 1, similarLimit: 0, conceptLimit: 0, enableSimilar: false, enableConcept: false }, // 免費
  A: { dailyLimit: 10, similarLimit: 3, conceptLimit: 10, enableSimilar: true, enableConcept: true }, // 基本
  B: { dailyLimit: 30, similarLimit: 10, conceptLimit: 30, enableSimilar: true, enableConcept: true }, // 高級
  C: { dailyLimit: -1, similarLimit: -1, conceptLimit: -1, enableSimilar: true, enableConcept: true } // 鑽石
};

// 預設系統參數
export const DEFAULT_SYS_CONFIG = {
    pointCostQuestion: 5,
    pointCostQuiz: 10,
    pointCostConcept: 10,
    announcement: "", 
    disclaimer: "", 
    enableFullSubjects: false // 考前衝刺模式開關 (預設關閉)
};
